export default __webpack_public_path__ + "static/media/fad-logo-aax.a4c01d33.svg";